

const SvgIcon = ({ 
  height= '83',
  width = '83',
  fill = '#1E84B5'
}: {
  height: string;
  width: string;
  fill: string;
}) => {
  return (
    <svg xmlnsXlink="http://www.w3.org/1999/xlink" width={width} height={height} viewBox="0 0 83 83" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M82.8258 41.4129C48.4756 45.2652 45.2653 48.4755 41.4129 82.8257C37.5606 48.4755 34.3502 45.2652 0 41.4129C34.3502 37.5605 37.5606 34.3502 41.4129 0C45.2653 34.3502 48.4756 37.5605 82.8258 41.4129Z" fill={ fill} />
    </svg>
  );
};

export default SvgIcon;